import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import Verify from './views/auth/Verify';
import Auth from './layouts/auth';
import Dashboard from './layouts/dashboard';
import useStore from './store/useStore';

const AppRoutes = () => {
  const location = useLocation();

  const token = useStore((state) => state.token);

  if (location.pathname === '/verify') {
    return <Route exact path={'/verify'} component={Verify} />;
  }

  const getRoutes = () => {
    if (!token) {
      return <Auth />;
    }

    return (
      <Switch>
        <Dashboard />
      </Switch>
    );
  };

  return <>{getRoutes()}</>;
};

export default AppRoutes;
